import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  span {
    width: 100%;
    height: 35px;
  }
`
